import { useEventBus } from "@vueuse/core";
import { reactive, ref, computed } from "vue";
import { scrollToId } from "@scalar/helpers/dom/scroll-to-id";
const lazyEventBusKey = /* @__PURE__ */ Symbol();
const lazyBus = useEventBus(lazyEventBusKey);
ref(false);
const generateReverseIndex = (navigation = []) => {
  const mapping = /* @__PURE__ */ new Map();
  const dfs = (node) => {
    mapping.set(node.id, node);
    if ("children" in node) {
      node.children?.forEach(
        (it) => dfs({ ...it, parent: node })
      );
    }
  };
  navigation.forEach(dfs);
  return mapping;
};
const createSidebar = (store) => {
  const collapsedSidebarItems = reactive({});
  const isSidebarOpen = ref(false);
  const toggleCollapsedSidebarItem = (key) => {
    collapsedSidebarItems[key] = !collapsedSidebarItems[key];
  };
  const setCollapsedSidebarItem = (key, value) => {
    collapsedSidebarItems[key] = value;
  };
  const items = computed(() => {
    const result = store.workspace.activeDocument?.["x-scalar-navigation"];
    if (store.config["x-scalar-reference-config"].features.expandAllTagSections) {
      result?.forEach((entry) => setCollapsedSidebarItem(entry.id, true));
    }
    return {
      entries: result ?? [],
      entities: generateReverseIndex(result)
    };
  });
  const scrollToOperation = (operationId, focus) => {
    const sectionId = items.value.entities.get(operationId)?.parent?.id;
    if (sectionId && sectionId !== operationId) {
      if (!collapsedSidebarItems[sectionId]) {
        const unsubscribe = lazyBus.on((ev) => {
          if (ev.loaded === operationId) {
            scrollToId(operationId, focus);
            unsubscribe();
          }
        });
        setCollapsedSidebarItem(sectionId, true);
      } else {
        scrollToId(operationId, focus);
      }
    }
  };
  return {
    collapsedSidebarItems,
    isSidebarOpen,
    items,
    scrollToOperation,
    setCollapsedSidebarItem,
    toggleCollapsedSidebarItem
  };
};
export {
  createSidebar,
  generateReverseIndex,
  lazyBus
};
//# sourceMappingURL=create-sidebar.js.map
